import MainHeader from '~/components/Header';
import InternationalHeader from '~/components/Header/InternationalHeader';
import type { Region } from '~/utils/region';

interface DynamicHeaderProps {
  region: Region;
}

export const DynamicHeader = ({ region }: DynamicHeaderProps) => {
  if (!region || region.code === 'GB') return <MainHeader />;

  return <InternationalHeader />;
};
